import Route from "@ember/routing/route";
import { task, timeout } from "ember-concurrency";
import ENV from "glesys-controlpanel/config/environment";

export default class BlockStorageOverviewRoute extends Route {
  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  async model() {
    const project = this.modelFor("organization").project;
    const volumes = await project.get("blockStorageVolumes");
    return { project, volumes };
  }

  /* istanbul ignore next */
  volumeStatusLoopTask = task(async (project) => {
    if (ENV.environment === "test") {
      return;
    }
    while (true) {
      const volumes = await project.get("blockStorageVolumes");
      const allReady = volumes.every((volume) => volume.isReady);
      await timeout(allReady ? 60 * 1000 : 4 * 1000);
      await volumes.reload();
    }
  });

  setupController(controller, model) {
    super.setupController(controller, model);
    this.volumeStatusLoopTask.perform(model.project);
  }

  resetController(controller) {
    super.resetController(controller);
    this.volumeStatusLoopTask.cancelAll();
  }
}
